import React from 'react';
import { useProductRecommendations } from '../../integrations/relewise/hooks/useProductRecommendations';
import { RecommendedProductsCarousel } from '../../shared/components/recommended-products-carousel/recommended-products-carousel';
import { useLazyLoading } from '../../shared/hooks/useLazyLoading';
import { ICusRecommendedProductsProps, recommendationType as RecommendationType } from './cus-recommended-products.props.autogenerated';

const RecommendedProducts = (props: ICusRecommendedProductsProps<never>) => {
    const { context, config, resources } = props;
    const { recommendationType, productCount, relevanceModifier, title, displayLocation, relevanceModifierStrength } = config;

    // Conditional config fields need to be handled defensively in the code,
    // as the CMS does not enforce the condition but just hides the field in the editor
    const categoryId = recommendationType === RecommendationType.recentlyViewed ? undefined : config.categoryName;

    const { ref, isInView } = useLazyLoading();
    const { products, isLoading } = useProductRecommendations({
        productCount,
        recommendationType,
        isEnabled: isInView,
        displayLocation,
        categoryId,
        relevanceModifier,
        relevanceModifierStrength
    });

    return (
        <RecommendedProductsCarousel
            products={products}
            title={title}
            context={context}
            ctaLabel={resources.recommendedProductsCtaLabel}
            ref={ref}
            isLoading={!isInView || isLoading}
        />
    );
};

export default RecommendedProducts;
